export const PRE_WEBAUTHN_USER_ROLE = "pre_webauthn_user";
export const WEBAUTHN_USER_ROLE = "webauthn_user";
export const CLIENT_CERTIFICATE_USER = "client_certificate_user";
